export function onlyRusLetters(value) {
  // eslint-disable-next-line no-useless-escape
  const regex = /^[а-яА-ЯёЁ\s]*$/i;

  return regex.test(value);
}

// address: cyrillic, digits and punctuation, no latin letters
export function rusAddress(value) {
  const regex = /^[а-яА-ЯёЁ0-9\s.,\-/№()]*$/;

  return regex.test(value);
}

export function onlyNumbers(value) {
  // eslint-disable-next-line no-useless-escape
  const regex = /^[0-9]*$/i;

  return regex.test(value);
}

export function onlyLatLetters(value) {
  // eslint-disable-next-line no-useless-escape
  const regex = /^[A-Za-z\s]*$/;

  return regex.test(value);
}

export function passportSeriaAndNumber(value) {
  // eslint-disable-next-line no-useless-escape
  const seria = /^[0-9a-zA-Z]*$/i;

  return seria.test(value);
}

export function cardNumberValidation(value) {
  const regex = /^[0-9\s]*$/i;

  return regex.test(value);
}

export function emailValidation(value) {
  const regex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

  return regex.test(value);
}

export function exchangeRateValidation(value) {
  const regex = /^[0-9.]*$/i;

  return regex.test(value);
}
